import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';

import { configGetSettings } from 'common/helper/config/get-settings';
import { MyAccountBundleSettingsInterface } from 'common/module/my-account/bundle-settings.interface';
import { MyAccountViewCssSelectorEnum } from 'common/module/my-account/view-css-selector.enum';
import { PropertyCtaService } from 'common/module/property-cta/service';
import { PropertyCtaStatsService } from 'common/module/property-cta/stats/service';
import { AbTestService } from 'common/service/ab-test/service';
import { HeaderService } from 'common/service/header/service';
import { MessageService } from 'common/service/message/service';
import { MyAccountEmptyListViewStoreService } from 'common/service/my-account-empty-list-view-store/service';
import { PrivacyPromptService } from 'common/service/privacy-prompt/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { MyAccountViewFactory } from 'desktop/module/my-account/view.factory';
import { PropertyLeadEmailService } from 'desktop/module/property-lead-email/service';
import { PropertyLeadPhoneService } from 'desktop/module/property-lead-phone/service';
import { UserAvatarComponent } from 'desktop/module/user/avatar/component';

AbTestService().initialize();

// Common services
HeaderService()
  .setComponents({
    UserAvatarComponent,
  })
  .render();

MessageService().initialize();

PropertyLeadEmailService();
PropertyLeadPhoneService();
PropertyCtaService();
PropertyCtaStatsService();

PrivacyPromptService();

const bundleSettings = configGetSettings<MyAccountBundleSettingsInterface>();

// Initialize empty list
MyAccountEmptyListViewStoreService().initialize({
  ...bundleSettings.emptyList,
  isUserLoggedIn: !!UserAuthenticationService().getToken(),
});

const myAccountView = MyAccountViewFactory();

myAccountView.initialize({
  element: domQuerySelector(document, MyAccountViewCssSelectorEnum.element),
  categories: bundleSettings.form.category_id,
  sort: bundleSettings.form.sort,
  showDeleteButton: bundleSettings.showDeleteButton,
  listType: bundleSettings.listType,
});
myAccountView.render();
